// Import everything from autoload
import './autoload/_bootstrap.js';

import Splide from '@splidejs/splide';
window.Splide = Splide;

var currentBreakpoint = require('./util/currentBreakpoint').currentBreakpoint;
window.currentBreakpoint = currentBreakpoint;

import StickySidebar from 'sticky-sidebar';
window.StickySidebar = StickySidebar;

// import then needed Font Awesome functionality
import { library, dom } from '@fortawesome/fontawesome-svg-core';
// import the Facebook and Twitter icons
import {
  faPlusCircle,
  faMinusCircle,
  faEnvelope,
  faFilePdf,
  faCheck,
  faExclamation,
  faArrowRight,
} from '@fortawesome/free-solid-svg-icons';
import {
  faFacebookF,
  faTwitter,
  faInstagram,
  faLinkedinIn,
} from '@fortawesome/free-brands-svg-icons';

// add the imported icons to the library
library.add(
  faPlusCircle,
  faMinusCircle,
  faFacebookF,
  faTwitter,
  faEnvelope,
  faInstagram,
  faLinkedinIn,
  faFilePdf,
  faCheck,
  faExclamation,
  faArrowRight
);

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();

// import local dependencies
import './util/frHelper';
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import singleWorkstream from './routes/single-workstream';
import singleProgram from './routes/single-program';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  singleWorkstream,
  singleProgram,
});

// Load Events
$(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js